import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Typography, CircularProgress } from "@mui/material";
import {
  fetchStoreCodes,
  fetchStoreDetails,
  setEditing,
} from "../../Store/Gmb/gmbStoreSlice";
import StoreCodeInput from "./StoreCodeInput";
import GMBProfileDetail from "./GMBProfileDetails/GMDProfileDetail";
import NoAssetSVG from "./NoAssetSVG";
import { resetForm } from "../../Store/Gmb/gmbProfileSlice";
import { resetUploadState } from "../../Store/Gmb/gmbImageSlice";
import { resetVerification } from "../../Store/Gmb/gmbVerificationSlice";
import { resetPostData } from "../../Store/Gmb/gmbPostSlice";
import { useParams,useLocation } from "react-router-dom";

const GMB = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isTyping, setIsTyping] = useState(false);
  const { storeCodes, storeDetail, isLoading, isEditing } = useSelector(
    (state) => state.gmbStore
  );

  const {gmbStoreCode} = useParams();
 
  useEffect(() => {
    dispatch(fetchStoreCodes());
  }, [dispatch]);

  useEffect(() => {
    if(gmbStoreCode){
      dispatch(fetchStoreDetails(gmbStoreCode));
    }
  }, [gmbStoreCode]);

  const handleStoreSelect = (storeCode) => {
    //reset the state of form before fetching the store details
    dispatch(resetForm());
    dispatch(resetUploadState());
    dispatch(resetVerification());
    dispatch(resetPostData());
    if (storeCode ) {
      window.history.pushState({}, '', `/gmb/${storeCode.store_code}`);
      dispatch(fetchStoreDetails(storeCode.store_code));
    }
  };

  const handleTyping = () => {
    setIsTyping(true);
  };

  useEffect(() => {
    if (storeCodes?.length > 0) {
      setIsTyping(false);
    }
  }, [storeCodes]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 48px)", // total height - header height
        overflowY: "auto",
        paddingLeft: "12px",
        paddingRight: "16px",
      }}
    >
      <div
        style={{
          backgroundColor: "#FFFFFF",
          outline: "2px solid #F1F9FA",
          borderRadius: 20,
          padding: "16px",
          marginTop: "24px",
          paddingBottom: "8px",
          paddingTop: "12px",
        }}
      >
        <Typography
          variant="h6"
          style={{
            color: "#172128",
            fontWeight: "400",
          }}
        >
          GMB - Profile Management
        </Typography>
        <Typography
          variant="body2"
          style={{
            color: "#808C96",
            paddingTop: "4px",
          }}
        >
          This module will help in managing the data of all the Google business
          profiles.
        </Typography>

        <div style={{ marginTop: "8px" }}>
          <Typography
            htmlFor="input-group-1"
            variant="caption"
            style={{ color: "#172128" }}
          >
            Store code
          </Typography>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              position: "relative",
              width: 800,
              // maxWidth:"50%"
            }}
          >
            <StoreCodeInput
              // storeCodes={storeCodes}
              onStoreSelect={handleStoreSelect}
              disabled={isEditing}
              onInputChange={handleTyping}
            />
          </div>
        </div>
      </div>

      {!storeDetail ? (
        <div
          style={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#F1F6FA",
            borderRadius: "12px",
            marginTop: "16px",
          }}
        >
          <NoAssetSVG />
        </div>
      ) : (
        <GMBProfileDetail />
      )}
    </div>
  );
};

export default GMB;
